<!-- xx页面 -->
<template>
  <div class='dailyStatistics' ref="box">
    <div class="search" ref="topBox">
      <div class="box-left">
        <el-date-picker
          v-model="dateTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          placeholder="选择日期">
        </el-date-picker>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
      <div class="box-right">
        <div class="day" @click="handleClickColor('day')" :class="boxColor == 'day' ? 'boxShow' : ''">白天睡眠</div>
        <div class="day" @click="handleClickColor('night')" :class="boxColor == 'night' ? 'boxShow' : ''">夜晚睡眠</div>
      </div>
    </div>
    <div class="echartsBox" :style="{height: tableHeight}">
      <div class="chartTop">
        <div style="margin-right: 15px;">
          <div class="echartStyle">
            <h3>睡眠时间统计</h3>
            <sleep-time :sleepData="sleepData"></sleep-time>
          </div>
          <div class="sleepTitle">
            <div class="leftTltle">
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #9961F6;"></i><span>睡眠时长</span></div>
                <div>{{sleepTotalData.abedDuration == null ? '00' : sleepTotalData.abedDuration.slice(0,2)}}<span>时</span>{{sleepTotalData.abedDuration == null ? '00' : sleepTotalData.abedDuration.slice(3,5)}}<span>分</span> <i :style="{color: sleepTotalData.abedDuration == null ? '' : sleepTotalData.abedDuration.slice(0,2)>=8 ? '#61C32B' : sleepTotalData.abedDuration.slice(0,2)<6 ? '#FF1935' : ''}">{{sleepTotalData.abedDuration == null ? '' : sleepTotalData.abedDuration.slice(0,2)>=8 ? '⬆' : sleepTotalData.abedDuration.slice(0,2)<6 ? '⬇' : ''}}</i></div>
                <div>[参考值:6--8]</div>
              </div>
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #514DF1;"></i><span>深度睡眠</span></div>
                <div>{{sleepTotalData.deepSleep == null ? '00' : sleepTotalData.deepSleep.kindOfTime.slice(0,2)}}<span>时</span>{{sleepTotalData.deepSleep == null ? '00' : sleepTotalData.deepSleep.kindOfTime.slice(3,5)}}<span>分</span> <i :style="{color: sleepTotalData.deepSleep == null ? '' : sleepTotalData.deepSleep.kindOfTime.slice(0,2)>=3 ? '#61C32B' : sleepTotalData.deepSleep.kindOfTime.slice(0,2)<2 ? '#FF1935' : ''}">{{sleepTotalData.deepSleep == null ? '' : sleepTotalData.deepSleep.kindOfTime.slice(0,2)>=3 ? '⬆' : sleepTotalData.deepSleep.kindOfTime.slice(0,2)<2 ? '⬇' : ''}}</i></div>
                <div>[参考值:2--3]</div>
              </div>
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #51AFF2;"></i><span>中度睡眠</span></div>
                <div>{{sleepTotalData.moderateSleep == null ? '00' : sleepTotalData.moderateSleep.kindOfTime.slice(0,2)}}<span>时</span>{{sleepTotalData.moderateSleep == null ? '00' : sleepTotalData.moderateSleep.kindOfTime.slice(3,5)}}<span>分</span> <i :style="{color: sleepTotalData.moderateSleep == null ? '' : sleepTotalData.moderateSleep.kindOfTime.slice(0,2)>=4 ? '#61C32B' : sleepTotalData.moderateSleep.kindOfTime.slice(0,2)<3 ? '#FF1935' : ''}">{{sleepTotalData.moderateSleep == null ? '' : sleepTotalData.moderateSleep.kindOfTime.slice(0,2)>=4 ? '⬆' : sleepTotalData.moderateSleep.kindOfTime.slice(0,2)<3 ? '⬇' : ''}}</i></div>
                <div>[参考值:3--4]</div>
              </div>
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #B1DE58;"></i><span>浅度睡眠</span></div>
                <div>{{sleepTotalData.lightSleep == null ? '00' : sleepTotalData.lightSleep.kindOfTime.slice(0,2)}}<span>时</span>{{sleepTotalData.lightSleep == null ? '00' : sleepTotalData.lightSleep.kindOfTime.slice(3,5)}}<span>分</span> <i :style="{color: sleepTotalData.lightSleep == null ? '' : sleepTotalData.lightSleep.kindOfTime.slice(0,2)>=5 ? '#61C32B' : sleepTotalData.lightSleep.kindOfTime.slice(0,2)<4 ? '#FF1935' : ''}">{{sleepTotalData.lightSleep == null ? '' : sleepTotalData.lightSleep.kindOfTime.slice(0,2)>=5 ? '⬆' : sleepTotalData.lightSleep.kindOfTime.slice(0,2)<4 ? '⬇' : ''}}</i></div>
                <div>[参考值:4--5]</div>
              </div>
            </div>
            <div class="leftTltle">
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #F9C570;"></i><span>清醒时长</span></div>
                <div>{{sleepTotalData.sober == null ? '00' : sleepTotalData.sober.kindOfTime.slice(0,2)}}<span>时</span>{{sleepTotalData.sober == null ? '00' : sleepTotalData.sober.kindOfTime.slice(3,5)}}<span>分</span> <i :style="{color: sleepTotalData.sober == null ? '' : sleepTotalData.sober.kindOfTime.slice(0,2)>=2 ? '#61C32B' : sleepTotalData.sober.kindOfTime.slice(0,2)<1.5 ? '#FF1935' : ''}">{{sleepTotalData.sober == null ? '' : sleepTotalData.sober.kindOfTime.slice(0,2)>=2 ? '⬆' : sleepTotalData.sober.kindOfTime.slice(0,2)<1.5 ? '⬇' : ''}}</i></div>
                <div>[参考值:1.5--2]</div>
              </div>
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #447AFE;"></i><span>清醒次数</span></div>
                <div>{{sleepTotalData.soberNumber == null ? '0次' : sleepTotalData.soberNumber + '次'}} <i :style="{color: sleepTotalData.soberNumber == null ? '' : sleepTotalData.soberNumber>2 ? '#61C32B' : sleepTotalData.soberNumber<0 ? '#FF1935' : ''}">{{sleepTotalData.soberNumber == null ? '' : sleepTotalData.soberNumber>2 ? '⬆' : sleepTotalData.soberNumber<0 ? '⬇' : ''}}</i></div>
                <div>[参考值:0--2]</div>
              </div>
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #FFB900;"></i><span>平均心率</span></div>
                <div>{{breatheHeartRate.avgHeartRate == null ? '0次/分' : breatheHeartRate.avgHeartRate + '次/分'}} <i :style="{color: breatheHeartRate.avgHeartRate == null ? '' : breatheHeartRate.avgHeartRate>100 ? '#61C32B' : breatheHeartRate.avgHeartRate<60 ? '#FF1935' : ''}">{{breatheHeartRate.avgHeartRate == null ? '' : breatheHeartRate.avgHeartRate>100 ? '⬆' : breatheHeartRate.avgHeartRate<60 ? '⬇' : ''}}</i></div>
                <div>[参考值:60--100]</div>
              </div>
              <div class="boxSon">
                <div><i class="yuan" style="backgroundColor: #FF1935;"></i><span>平均呼吸率</span></div>
                <div>{{breatheHeartRate.averageRespiratoryRate == null ? '0次/分' : breatheHeartRate.averageRespiratoryRate + '次/分'}} <i :style="{color: breatheHeartRate.averageRespiratoryRate == null ? '' : breatheHeartRate.averageRespiratoryRate>20 ? '#61C32B' : breatheHeartRate.averageRespiratoryRate<16 ? '#FF1935' : ''}">{{breatheHeartRate.averageRespiratoryRate == null ? '' : breatheHeartRate.averageRespiratoryRate>20 ? '⬆' : breatheHeartRate.averageRespiratoryRate<16 ? '⬇' : ''}}</i></div>
                <div>[参考值:16--20]</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sleepStatus">
          <div class="echartStyle">
            <h3>睡眠状态统计</h3>
            <div class="top">
              <div class="topLeft">
                <sleep-breathe :breatheHeartRate="breatheHeartRate"></sleep-breathe>
              </div>
              <div class="topRight">
                <div class="timeTop">
                  <div>
                    <span>{{sleepTotalData.bodyNumber ? sleepTotalData.bodyNumber : '0'}}</span>次
                    <div>体动次数</div>
                  </div>
                  <div>
                    <span>{{sleepTotalData.breatheAbnormalNumber ? sleepTotalData.breatheAbnormalNumber : '0'}}</span>次
                    <div>呼吸异常次数</div>
                  </div>
                </div>
                <div class="timeBottom">
                  <span>{{breatheHeartRate.sleepStartTime}}-{{breatheHeartRate.sleepEndTime}}</span>
                  <div>时间段</div>
                </div>
              </div>
            </div>
          </div>
          <div class="sleepInfo">
            <div class="infoTop" style="margin-bottom: 15px;">
              <div>
                <div class="title">
                  <div>呼吸过速/缓</div>
                  <div class="num">{{breatheHeartRate.breath ? '-' + breatheHeartRate.breath : '0'}}</div>
                </div>
                <div class="iconfontS position1"></div>
              </div>
              <div>
                <div class="title">
                  <div>弱呼吸</div>
                  <div class="num">{{breatheHeartRate.weakBreathing ? '-' + breatheHeartRate.weakBreathing : '0'}}</div>
                </div>
                <div class="iconfontS position4">
                </div>
              </div>
              <div>
                <div class="title">
                  <div>易清醒</div>
                  <div class="num">{{breatheHeartRate.sober ? '-' + breatheHeartRate.sober : '0'}}</div>
                </div>
                <div class="iconfontS position3">
                </div>
              </div>
              <div>
                <div class="title">
                  <div>体动</div>
                  <div class="num">{{breatheHeartRate.bodyMovement ? '-' + breatheHeartRate.bodyMovement : '0'}}</div>
                </div>
                <div class="iconfontS position8">
                </div>
              </div>
            </div>
            <div class="infoTop">
              <div>
                <div class="title">
                  <div>太晚睡</div>
                  <div class="num">{{breatheHeartRate.sleepLate ? '-' + breatheHeartRate.sleepLate : '0'}}</div>
                </div>
                <div class="iconfontS position2">
                </div>
              </div>
              <div>
                <div class="title">
                  <div>睡眠过短</div>
                  <div class="num">{{breatheHeartRate.sleepShort ? '-' + breatheHeartRate.sleepShort : '0'}}</div>
                </div>
                <div class="iconfontS position5">
                </div>
              </div>
              <div>
                <div class="title">
                  <div>睡眠过长</div>
                  <div class="num">{{breatheHeartRate.sleepLong ? '-' + breatheHeartRate.sleepLong : '0'}}</div>
                </div>
                <div class="iconfontS position6">
                </div>
              </div>
              <div>
                <div class="title">
                  <div>睡眠效率</div>
                  <div class="num">{{breatheHeartRate.sleepEfficiency ? '-' + breatheHeartRate.sleepEfficiency : '0'}}</div>
                </div>
                <div class="iconfontS position7">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chartBottom">
        <div style="margin-right: 15px;">
          <h3>心率统计</h3>
          <heart-statistics :heartRateStatistics="heartRateStatistics"></heart-statistics>
        </div>
        <div style="margin-right: 15px;">
          <h3>呼吸统计</h3>
          <breathe-statistics :heartRateStatistics="heartRateStatistics"></breathe-statistics>
        </div>
        <div>
          <h3>体动统计</h3>
          <sleep-times :heartRateStatistics="heartRateStatistics"></sleep-times>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import { debounce } from '@/utils/validate'
import sleepTime from "@/components/sleepMonitor/sleepTime"
import sleepBreathe from "@/components/sleepMonitor/sleepBreathe"
import heartStatistics from "@/components/sleepMonitor/heartStatistics"
import breatheStatistics from "@/components/sleepMonitor/breatheStatistics"
import sleepTimes from "@/components/sleepMonitor/sleepTimes"
export default {
  // import引入的组件需要注入到对象中才能使用
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
  },
  components: {
    sleepTime,
    sleepBreathe,
    heartStatistics,
    breatheStatistics,
    sleepTimes,
  },
  data () {
    // 这里存放数据
    return {
      dateTime: '',
      sleepData: {},
      sleepTotalData: {},
      breatheHeartRate: {},
      heartRateStatistics: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()- 3600 * 1000 * 24; // 今天之前禁用，减去一天的毫秒数，否则今天也将禁用
        }
      },
      boxColor: 'night',
      nightSleepMark: 1,
      isHome: 0,
      tableHeight: 'auto',
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // 初始化获取时间
    let date = new Date(); // 获取当前时间戳
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day = date.getDate();
    day = day < 10 ? "0" + day : day;
    this.dateTime = year + "-" + month + "-" + day;
    this.handleInfo()
    this.handleSleepTotal()
    this.handleBreathe()
    this.handleHeartRateStatistics()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.makeheight()
    window.onresize = debounce(this.makeheight)
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    // 动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight () {
      this.$nextTick(() => {
        let boxHeight = this.$refs.box.offsetHeight
        let topHeight = this.$refs.topBox.offsetHeight
        this.tableHeight = `${boxHeight - topHeight - 35}px`
      })
    },
    // 点击查询
    handleSearch () {
      this.handleInfo()
      this.handleSleepTotal()
      this.handleBreathe()
      this.handleHeartRateStatistics()
    },
    // 初始化获取数据
    handleInfo () {
      this.request.post('/front/device/sleep/sleepByDay', {
        deviceId: this.deviceId,
        time: this.dateTime,
        type: 0,
        nightSleepMark: this.nightSleepMark,
      }).then(res => {
        if (res.code == 200) {
          this.sleepData = res.data
        }
      })
    },
    // 获取睡眠统计数据
    handleSleepTotal () {
      this.request.post('/front/device/sleep/mulSleepDay', {
        deviceId: this.deviceId,
        type: 0,
        time: this.dateTime,
        nightSleepMark: this.nightSleepMark,
        isHome: this.isHome,
      }).then(res => {
        if (res.code == 200) {
          this.sleepTotalData = res.data
        }
      })
    },
    // 获取呼吸心率数据
    handleBreathe () {
      this.request.post('/front/device/sleep/sleepStatistics', {
        deviceId: this.deviceId,
        // deviceId: 829,
        type: 0,
        time: this.dateTime,
        nightSleepMark: this.nightSleepMark,
      }).then(res => {
        if (res.code == 200) {
          this.breatheHeartRate = res.data
        }
      })
    },
    // 获取心率统计数据
    handleHeartRateStatistics () {
      this.request.post('/front/device/sleep/queryStatistics', {
        deviceId: this.deviceId,
        type: 0,
        queryTime: this.dateTime + ' 23:59:59',
        nightSleepMark: this.nightSleepMark,
      }).then(res => {
        if (res.code == 200) {
          this.heartRateStatistics = res.data
        }
      })
    },
    // 点击白天黑夜切换颜色
    handleClickColor (type) {
      this.boxColor = type
      if (type == 'day') {
        this.nightSleepMark = 0
        this.isHome = 1
        this.handleSearch()
      } else {
        this.nightSleepMark = 1
        this.isHome = 0
        this.handleSearch()
      }
    },
  }
}
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
.dailyStatistics {
  height: 100%;
  width: 100%;
  .search {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .box-left {
      ::v-deep .el-date-editor {
        width: 135px;
        margin-right: 10px;
        .el-input__prefix {
          top: -4px !important;
        }
        .el-input__suffix {
          top: -4px !important;
        }
      }
      .el-button {
        padding: 0;
        height: 32px;
        width: 50px;
        background-color: #2177E6;
      }
    }
    .box-right {
      display: flex;

      >div{
        width: 70px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        margin-left: 15px;
        box-shadow: 0px 0px 8px #e6e6e6 inset;
        color: #7a7d81;
        border-radius: 3px;
      }
      .boxShow {
        box-shadow: 0px 0px 8px #2177e6 inset;
        color: #2177e6;
      }
    }
  }
  .echartsBox {
    width: 100%;
    height: calc(100% - 65px);
    background-color: #F4F7FA;
    margin-top: 15px;
    border-radius: 5px;
    padding: 14px;
    box-sizing: border-box;
    overflow-y: scroll;
    .chartTop {
      display: flex;
      >div {
        width: 49.6%;
        background-color: #fff;
        border-radius: 10px;
        height: 430px;
        padding: 15px;
        min-width: 785px;
        box-sizing: border-box;
        .echartStyle {
          height: 250px;
          >h3 {
            font-family: AlibabaPuHuiTi-Bold;
          }
          .top {
            display: flex;
            height: 200px;
            margin-top: 20px;
            >div {
              width: 50%;
            }
            .topLeft {
            }
            .topRight {
              padding-top: 40px;
              .timeTop {
                display: flex;
                padding: 0 50px;
                justify-content: space-between;
                box-sizing: border-box;
                >div {
                  text-align: center;
                  font-size: 14px;
                  span {
                    font-size: 40px;
                    font-family: AlibabaPuHuiTi-Bold;
                    color: #457CFF;
                  }
                  >div {
                    font-size: 14px;
                    color: #666666;
                  }
                }
              }
              .timeBottom {
                text-align: center;
                margin-top: 15px;
                >span {
                  font-size: 40px;
                  font-family: AlibabaPuHuiTi-Bold;
                  color: #457CFF;
                }
                >div {
                  font-size: 14px;
                  color: #666666;
                }
              }
            }
          }
        }
        .sleepTitle {
          display: flex;
          justify-content: space-between;
          .leftTltle {
            width: 40%;
            .boxSon {
              display: flex;
              font-size: 16px;
              margin-bottom: 10px;
              div:nth-child(1) {
                width: 105px;
                .yuan {
                  display: inline-block;
                  width: 14px;
                  height: 14px;
                  border-radius: 50%;
                  background-color: #000;
                  margin-right: 10px;
                  vertical-align: -2px;
                }
                span {
                  font-family: AlibabaPuHuiTi-Bold;
                  color: #333333;
                }
              }
              div:nth-child(2) {
                width: 80px;
                color: #3F86FF;
                font-weight: 600;
                span {
                  font-size: 12px;
                }
              }
              div:nth-child(3) {
                color: #999999;
                font-size: 14px;
                margin-top: 2px;
              }
            }
          }
        }
        .sleepInfo {
          .infoTop {
            display: flex;
            justify-content: space-between;
            >div {
              width: 23%;
              height: 67px;
              background-color: #E8EFFE;
              border-radius: 10px;
              padding: 8px 15px;
              box-sizing: border-box;
              display: flex;
              .title {
                width: 60%;
                font-size: 14px;
                color: #999999;
                .num {
                  font-size: 24px;
                  color: #333333;
                }
                >div {
                  margin-bottom: 5px;
                }
              }
              .iconfontS {
                width: 40%;
                text-align: center;
                line-height: 67px;
              }
              .position1 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px 10px;
              }
              .position2 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px -157px;
              }
              .position3 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px -33px;
              }
              .position4 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px -200px;
              }
              .position5 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px -71px;
              }
              .position6 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px -241px;
              }
              .position7 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px -113px;
              }
              .position8 {
                background: url(../../../assets/img/sleep/Sprite.png) no-repeat;
                background-size: 50%;
                background-position: 20px -285px;
              }
            }
          }
        }
      }
    }
    .chartBottom {
      display: flex;
      margin-top: 20px;
      >div {
        width: 32.8%;
        height: 280px;
        min-width: 515px;
        background-color: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 15px;
        >h3 {
            font-family: AlibabaPuHuiTi-Bold;
          }
      }
    }
  }
}
</style>
